import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { CustomerReceiptPaymentFormComponent } from "../customer-receipt-payment-form/customer-receipt-payment-form.component";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "ngx-customer-receipt-payment-list",
  templateUrl: "./customer-receipt-payment-list.component.html",
  styleUrls: ["./customer-receipt-payment-list.component.scss"],
})
export class CustomerReceiptPaymentListComponent extends BaseListComponent {
  unSortableFilterable: string[] = [];
  filters: GridFilter[] = [
    {
      Filed: "Code",
      Value: 0,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    },
  ];

  constructor() {
    super();
    this.inputEditorform = CustomerReceiptPaymentFormComponent;
  }
  ngOnInit() {
    this.apiName = "CustomerSettlemet";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Financial.ReceiptPayments");
    const info = this.accountService.authService.currentInformation();
    if (
      (info.BranchingAdvancedEnabled || info.BranchingLightEnabled || info.RestaurantCallCenter) &&
      !this.accountService.authService.currentBranch?.AccessToAllBranches
    ) {
      this.filters.push({
        Filed: "BranchId",
        Value: this.accountService.authService.currentBranchId,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      });
    }
    const columnsToExclude = [
      "CustomerCode",
      "CustomerTitle",
      "ReceiptPaymentTypeTitle",
      "PaymentMethodTypeTitle",
      "PaymentAmount",
      "ReciptAmount",
      "UntilDateClear",
    ];

    this.unSortableFilterable.push(...columnsToExclude);
  }
}
